import React from 'react';
import { Outlet } from 'react-router-dom';
import utils from 'utils';
import routes from './routes';
import FmSubNavigation from '../../components/FmSubNavigation';

import './Vehicles.styles.scss';

const dashSubRoutes = utils.createNavRoute(routes);

const VehiclesRouter: React.FC = () => {
  return (
    <div className="vehicles-router">
      {dashSubRoutes.length > 1 && <FmSubNavigation routes={dashSubRoutes} />}
      <Outlet />
    </div>
  );
};

export default VehiclesRouter;
